module.exports = __webpack_public_path__ + "static/img/produce07.8079614.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce07.png
// module id = 137
// module chunks = 4